import CoreIcon from './CoreIconSmall';
import CoreIconV2 from './CoreIconSmall.v2';
import { withFeatureBranch } from '../../redux/flags';
export default withFeatureBranch({
    core_packages: CoreIconV2,
})(CoreIcon);
//# sourceMappingURL=index.js.map